import styled, { css } from 'styled-components';

import { Color } from '../../../constants/Colors';
import { Typography } from '../../../constants/Typographies';

export const Wrapper = styled.table`
  margin-top: 30px;
  display: flex;
  width: 100%;
  table-layout: fixed;
  display: inline-table;
`;

export const StyledHead = styled.thead``;

export const StyledBody = styled.tbody``;

export const StyledRow = styled.tr``;

const StyledData = css`
  border: 2px solid ${Color.MYSTIC};
  text-align: center;
  padding: 8px;
  vertical-align: middle;
`;

export const StyledTitle = styled.td`
  ${StyledData}
  ${Typography.XL_BOLDER}
  background-color: ${Color.BLUE_RIBBON};
  color: ${Color.WHITE};
`;

export const SimpleColumn = styled.td`
  ${StyledData}
  background-color: ${Color.WHITE};
`;

export const GradeColumn = styled.td`
  ${StyledData}
  background-color: ${Color.ZIRCON};
`;

export const GradeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 4px;
`;

export const GradeLabel = styled.span`
  ${Typography.XS_BOLDER}
  color: ${Color.CLOUD_BURST};
`;

export const StarWrapper = styled.div``;

export const Star = styled.span``;

export const PictureWrapper = styled.div`
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px 30px;
  width: 50%;
  margin: auto;
  overflow: hidden;
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
